import * as yup from 'yup';
const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "application/pdf"
];

const XLSX_SCHEMA = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
]

const FILE_SIZE = 160 * 1024;
const emailRegex = new RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i);

const webRegex = new RegExp(/^((ftp|http|https):\/\/)?(www\.)?(?!.*(ftp|http|https|www\.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/);

// const phoneRegex = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
const phoneRegex = new RegExp(/^\d{1,15}$/);

// const gstRegex = RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/)


export const AddMerchantSchema = yup.object({
    merchantName: yup.string().required("Merchant name is required!"),
    address: yup.string().required("Address is required!"),

    
    country: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Country is required!"),

    state: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("State is required!"),

    city: yup.string().required("City is required!"),
    mobileNumber: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    // phone: yup.string().required("Phone number is required!"),
    contactPerson: yup.string().required("Contact person is required!"),
    emailAddress: yup.string()
        .email("Email must be a valid email address")
        .required("Email is required!"),
    // gstNumber: yup.string()
        // .matches(gstRegex, "Invalid GST number")
        // .required("GST Number is required!"),
    // authorizationCode: yup.string().required("Authorization code is required!"),
    // token: yup.string().required("Token is required"),
    password: yup.string().required("Password is required!"),
    cnfmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Both passwords need to be the same.")
    .when("password", (password, schema) =>
        password ? schema.required("Confirm password field is required!") : schema
    ),
    //Brand access//
   
        brandAccess: yup.array().of(
        yup.object().shape({
          brandId: yup
            .mixed()
            .transform((originalValue) => originalValue?.value ?? "")
            .required("Brand is required!"),
          productId: yup
            .array()
            .transform((originalValue) =>
              Array.isArray(originalValue)
                ? originalValue.map((item) => item?.value ?? "")
                : []
            )
            .min(1, "Product name is required!")
            .required("Product name is required!"),
          margin: yup
            .number()
            .typeError("Margin must be a number.")
            .positive("Margin must be a positive number.")
            .max(100, "Margin should not be more than 100%.")
            .required("Margin offered is required!")
        })
      )
});
export const AddProductSchema = yup.object({
    productBrand: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Brand is required!"),
    margin: yup.number().min(1, 'Invalid, must be between 1-100.').max(100, 'Invalid, must be between 1-100.').required('Margin is required!'),
    trashHold: yup.number().positive("Invalid, must be a positive number").required("Minimum quantity is required!"),
    master:yup.array().required("master is required!").nullable(),
    productDenomination: yup.string().required("Product Denomination name is required!"),
    productDenominationAmt: yup.number().positive().required("Product Denomination Amt is required!"),
    productSku: yup.string().required("Product SKU is required!"),
   
    // ProductArr: yup.array().of(yup.object().shape(
    //  {
    //  }
    // ))
});

export const AddMasterProductSchema = yup.object({
    brandId: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Brand name is required!"),
    name:yup.string().required("Master product is required!"),
    price: yup.string().required("Price is required!"),
    margin: yup.number().min(1, 'Invalid, must be between 1-100.').max(100, 'Invalid, must be between 1-100.').required('Margin is required!'),
    thresholdValue: yup.string().required("Minimum quantity is required!"),
    denomination: yup.string().required("Denomination is required!")
});

export const StockTransferSchema = yup.object({
    fromMasterProductId: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Transfer From product is required!"),
    toMasterProductId: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Transfer To product is required!"),
    quantity: yup
    .number()
    .typeError("Quantity must be a number")
    .integer("Quantity must be a whole number")
    .min(1, "Quantity must be at least 1")
    .required("Quantity is required!"),
    remarks: yup.string().max(255, "Remarks must be under 255 characters"),
});

export const EditMasterProductSchema = yup.object({
    brandId: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Brand name is required!"),
    name: yup.string().required("Master Product is required!"),
    price: yup.string().required("Price is required!"),
    margin: yup.number().min(1, 'Invalid, must be between 1-100.').max(100, 'Invalid, must be between 1-100.').required('Margin is required!'),
    thresholdValue: yup.string().required("Minimum quantity is required!"),
    denomination: yup.string().required("Denomination is required!")
});

export const EditProductSchema = yup.object({
    productBrand: yup.string().required("Brand is required!"),
    price: yup.string().required("Price is required!"),
    margin: yup.number().min(1, 'Invalid, must be between 1-100.').max(100, 'Invalid, must be between 1-100.').required('Margin is required!'),
    productDenomination: yup.string().required("Product denomination is required!"),
    productName: yup.string().required("Product Name is required!"),
    trashHold: yup.number().positive("Invalid, must be a positive number").required("Minimum quantity is required!"),
    master:yup.array().required("master is required!").nullable(),
    sku: yup.string().required("Product SKU is required!"),


});

export const AddBulkUploadSchema = yup.object({
    // productBrand: yup.string().required("Brand is required!"),
    master: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Master Product is required!"),
    // batchNumber: yup.string().required("Batch number is required!"),
    ProductKey: yup.mixed().required("A file is required!")
        .test(
            "fileFormat",
            "Unsupported format please add xlsx files",
            value => value && XLSX_SCHEMA.includes(value.type)
        )
});

//
export const CreateOrderSchema = yup.object({
    selectMerchant: yup
    .mixed()
    .transform((originalValue) => {
        if (typeof originalValue === 'object' && originalValue !== null) {
        return originalValue.value;
        }
        return originalValue;
    })
    .required("Select Merchant is required!"),
    selectProduct: yup
    .mixed()
    .transform((originalValue) => {
        if (typeof originalValue === 'object' && originalValue !== null) {
        return originalValue.value;
        }
        return originalValue;
    })
    .required("Select Product is required!"),
    quantity: yup.number().positive().required('Quantity is required!'),
    amount: yup.number().positive().required('Amount is required!'),
});
//

export const EditMerchantSchema = yup.object({
    merchantName: yup.string().required("Merchant name is required!"),
    address: yup.string().required("Address is required!"),
    country: yup.object().shape({
        value: yup.string().required("Country is required"),
        label: yup.string(),
    }).required("Country is required"),
    state: yup.object().shape({
        value: yup.string().required("State is required"),
        label: yup.string(),
    }).required("Country is required"),
    city: yup.string().required("City is required!"),
    mobileNumber: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    // phone: yup.string().required("Phone number is required!"),
    contactPerson: yup.string().required("Contact person is required!"),
    emailAddress: yup.string()
        .email("Invalid email!")
        .required("Email is required!"),
    // gstNumber: yup.string()
        // .matches(gstRegex, "Invalid GST number")
        // .required("GST Number is required!"),
    // authorizationCode: yup.string().required("Authorization code is required!"),
    // token: yup.string().required("Token is required"),
    //Brand access//
    brandAccess: yup.array().of(
        yup.object().shape({
          brandId: yup
            .mixed()
            .transform((originalValue) => originalValue?.value ?? "")
            .required("Brand is required!"),
          productId: yup
            .array()
            .transform((originalValue) =>
              Array.isArray(originalValue)
                ? originalValue.map((item) => item?.value ?? "")
                : []
            )
            .min(1, "Product name is required!")
            .required("Product name is required!"),
          margin: yup
            .number()
            .typeError("Margin must be a number.")
            .positive("Margin must be a positive number.")
            .max(100, "Margin should not be more than 100%.")
            .required("Margin offered is required!")
        })
      )
      
      
});

export const ReStockSchema = yup.object({
    BatchNumber: yup.string().required("Batch number is required!"),
    ProductKey: yup.mixed().required("A file is required!")
        .test(
            "fileFormat",
            "Unsupported Format Please add xlsx files",
            value => value && XLSX_SCHEMA.includes(value.type)
        )
});

export const TransactionSchema = yup.object({
    TransactionQuantity: yup.string().required("Transaction Quantity is required!"),
    TransactionAmount: yup.string().required("Transaction Amount is required!"),
    ProductKey: yup
        .mixed()
        .required("A file is required!")
});
export const SetTransactionSchema = yup.object({
    TransactionQuantity: yup.number().required("Transaction Quantity is required!"),
    TransactionAmount: yup.number().required("Transaction Amount is required!")
});

export const TopUpSchema = yup.object({
    amount: yup.string().required("Amount is required!"),
    // paymentMode: yup.string().required("Payment mode is required!"),
    paymentMode: yup
    .mixed()
    .transform((originalValue) => originalValue?.value ?? "")
    .required("Payment mode required!"),
    txnId: yup.string().required("Transaction Id is required!"),
    paymentDate:yup.string().required("Date is required!"),
    // txnProof: yup.string().required("Transaction proof is required!")
});
export const AddBrandSchema = yup.object({
    BrandName: yup.string().required("Brand Name is required!"),
    CompanyName: yup.string().required("Company Name  is required!"),
    // PhoneNumber: yup.string().matches(phoneRegex, "Invalid Phone Number").required("Phone Number is required!"),
    website: yup.string().matches(webRegex, "Invalid Website URL!").required("Website is required!"),
    // email: yup.string().email('Invalid email').required("Email is required!"),
    // address: yup.string().required("Address is required!"),
});
export const AddAgentSchema = yup.object({
    usersName: yup.string().required("Agent name is required!"),
    usersUserType: yup.string().required("Agent type is required!"),
    usersUserName: yup.string().required("User name is required!"),
    usersPhone: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    usersEmail: yup.string().email('Invalid email.').required("Email is required!"),
    // usersBrand:  yup.object().nullable().required("Brand is required!"),
    usersPassword: yup.string().required("Password field is required!"),
    confpassword: yup.string().when("usersPassword", (usersPassword, schema) => {
        return usersPassword
            ? schema
                .oneOf([yup.ref("usersPassword")], "Both password need to be the same.")
                .required("Confirm password field is required!")
            : schema;
        }),
        agentRegions: yup
        .array()
        .of(
            yup.object().shape({
            value: yup.string().required(),
            label: yup.string().required(),
            })
        )
        .min(1, "At least one region must be selected")
        .required("Region is required"),
});

export const EditAgentSchema = yup.object({
  usersName: yup.string().required("Agent name is required!"),
  usersUserType: yup.string().required("Agent type is required!"),
  usersUserName: yup.string().required("User name is required!"),
  usersPhone: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
  usersEmail: yup.string().email('Invalid email.').required("Email is required!"),

  usersPassword: yup.string().nullable(), // allow blank for edit mode
  confpassword: yup.string().test(
    "passwords-match",
    "Confirm password does not match.",
    function (value) {
      const { usersPassword } = this.parent;
      if (usersPassword) {
        return usersPassword === value;
      }
      return true; // skip validation if usersPassword is blank
    }
  ),

  agentRegions: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
    )
    .min(1, "At least one region must be selected")
    .required("Region is required"),
});


export const SettingSchema = yup.object().shape({
    AgentName: yup.string().required("Name is required!"),
    email: yup.string().required("Email is required!"),
    password: yup.string(),
    confpassword: yup.string().test(
        "passwords-match",
        "Confirm password does not match.",
        function (value) {
            const { password } = this.parent;
            if (password) {
                return password === value;
            }
            return true;
        }
    )
});

export const AddSupportSchema = yup.object({
    usersName: yup.string().required("Support name is required!"),
    usersUserType: yup.string().required("Agent type is required!"),
    usersMerchentIds: yup.array().nullable().required("Merchant is required!"),
    usersUserName: yup.string().required("User name is required!"),
    usersPhone: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    usersEmail: yup.string().email('Invalid email').required("Email is required!"),
     usersPassword: yup.string().required("Password field is required!"),
    confpassword: yup.string().when("usersPassword", (usersPassword, schema) => {
        return usersPassword
            ? schema
                .oneOf([yup.ref("usersPassword")], "Both password need to be the same.")
                .required("Confirm password field is required!")
            : schema;
        }),
});
export const EditSupportSchema = yup.object({
    usersName: yup.string().required("Support name is required!"),
    usersUserType: yup.string().required("Agent type is required!"),
    usersMerchentIds: yup.array().nullable(true).required("Merchant is required!"),
    usersUserName: yup.string().required("User name is required!"),
    usersPhone: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    usersEmail: yup.string().required("Email is required!"),
    // usersStatus: yup.array().required("User status is required!"),
    usersPassword: yup.string().nullable(), // allow blank for edit mode
    confpassword: yup.string().test(
        "passwords-match",
        "Confirm password does not match.",
        function (value) {
        const { usersPassword } = this.parent;
        if (usersPassword) {
            return usersPassword === value;
        }
        return true; // skip validation if usersPassword is blank
        }
    ),
});
export const AddOrderSchema = yup.object({
    // customerName: yup.string().required("Customer name is required!"),
    // contactName: yup.string().required("Contact name is required!"),
    // phoneNumber: yup.number().min(10).max(10).required("Phone Number is required!"),
    // productName: yup.string().required("Product name is required!"),
    // quantity: yup.string().required("Quantity is required!"),
    // productName1: yup.string().required("Product name is required"),
    // gstInPercent: yup.string().required("GST is required!"),
    // priceInclGst: yup.string().required("Price Number is required!"),
    // paymentStatus: yup.string().required("Payment status is required!"),
    //Brand access//
    productAccess: yup.array().of(
        yup.object().shape({
          quantity: yup
            .string()
            .required("Quantity is required!"),
          productName: yup
            .mixed()
            .transform((originalValue) => originalValue?.value ?? "")
            .required("Product is required!")
        })
      )

});
export const AddOrderCommentSchema = yup.object({
    productAccess: yup.array().of(yup.object().shape(
        {
            orderstatus: yup.string().required("Orderstatus is required!"),
            comment: yup.string().required("comment  is required!")
        }))

});
export const ViewOrderSchema = yup.object({
    customerName: yup.string().required("Customer name is required!"),
    contactName: yup.string().required("Contact name is required!"),
    phoneNumber: yup.number().min(10).max(10).required("Phone Number is required!"),
    productName: yup.string().required("Product name is required!"),
    quantity: yup.string().required("Quantity is required!"),
    productName1: yup.string().required("Product name is required!"),
    gstInPercent: yup.string().required("GST is required!"),
    priceInclGst: yup.string().required("Price Number is required!"),
    paymentStatus: yup.string().required("Payment status is required!"),
    uploadPayDocs: yup
        .mixed()
        .required("A file is required!")
        .test(
            "fileSize",
            "File too large",
            value => value && value.size <= FILE_SIZE
        )
        .test(
            "fileFormat",
            "Unsupported Format",
            value => value && SUPPORTED_FORMATS.includes(value.type)
        ),
});

//
export const EditCustomerInfoSchea = yup.object({
    name:yup.string().required("Customer Name is required!"),
    email: yup.string().matches(emailRegex, "Invalid email!").required("Email is required!"),
    phone: yup
    .string()
    .matches(phoneRegex, "Enter a valid mobile number (1–15 digits only)!")
    .required("Mobile number is required!"),
    address:yup.string().required("Address is required!"),
});
